import React from 'react';
import { Card, Heading, Paragraph } from 'bumbag';
import _get from 'lodash/get';

import sdk from '@medipass/web-sdk';
type Props = {
  className?: string | null | undefined;
};
export default class FirstTimeLoginGreeting extends React.PureComponent<Props> {
  static defaultProps = {
    className: null,
  };
  render = () => {
    const { className } = this.props;

    const isFirstTimeLogin = _get(sdk, 'account.isFirstTimeLogin');

    const firstName = _get(sdk, 'member.firstName');

    return isFirstTimeLogin ? (
      // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
      <Card className={className}>
        <Heading use="h6" lineHeight="1.5">
          Congratulations, {firstName}!<br /> Your account has been created.
        </Heading>
        <Paragraph>
          Welcome to your Tyro Health portal. This is where you can view your transactions, manage payment cards &
          personal details, review your quotes, and more.
        </Paragraph>
      </Card>
    ) : null;
  };
}
